import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-compart-type-comment',
  templateUrl: './view-compart-type-comment.component.html',
  styleUrls: ['./view-compart-type-comment.component.scss']
})
export class ViewCompartTypeCommentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
